import request from '@/utils/request'

// 查询韩国标准列表
export function listZltsHgbz(query) {
  return request({
    url: '/web/zlts/bzfw/zltsHgbz/list',
    method: 'get',
    params: query
  })
}

// 查询韩国标准详细
export function getZltsHgbz(recid) {
  return request({
    url: '/web/zlts/bzfw/zltsHgbz/' + recid,
    method: 'get'
  })
}
